import { msg } from "@lingui/core/macro";
import {
  primaryPatientIdentifierType,
  type IOrganization,
} from "@medoma/models/organizations";
import { personalIdentityNumberTypeSchema } from "@medoma/models/patients";

const getPersonalIdentityNumberLabel = (organization: IOrganization) => {
  const identifierType = primaryPatientIdentifierType(organization);
  switch (identifierType) {
    case personalIdentityNumberTypeSchema.enum.SwedishPersonalIdentityNumber:
      return msg`Personnummer`;
    case personalIdentityNumberTypeSchema.enum.SwissEMedicusNumber:
      return msg`e-Medicus-nummer`;
    case personalIdentityNumberTypeSchema.enum.SwissPatientNumber:
      return msg`Patientnummer`;
    case personalIdentityNumberTypeSchema.enum.LatvianPersonasKods:
      return msg`Personas kods`;
    default:
      throw identifierType satisfies never;
  }
};

export const getPatientTableColumnDisplayNames = (
  organization: IOrganization,
) => ({
  familyName: msg`Efternamn`,
  givenName: msg`Förnamn`,
  ward: msg`Avdelning`,
  personalIdentityNumber: getPersonalIdentityNumberLabel(organization),
  referringUnit: msg`Remitterande enhet`,
  patientType: msg`Patienttyp`,
  area: msg`Område`,
  team: msg`Team`,
  primaryResponsible: msg`Patientansvarig`,
  placeOfAssessment: msg`Plats för bedömning`,
});
